module.exports = __webpack_public_path__ + "static/img/logo.58663c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layout/logo.png
// module id = SSIb
// module chunks = 1